import React from 'react'
import {
  Flex,
  LoadingState,
  TableComponents,
  TimeAgo,
  Tooltip,
  Truncate,
} from '@sketch/components'
import { AuditActionPill } from './AuditActionPill'
import {
  DetailsCell,
  StyledAuditLogTable,
} from './WorkspaceAuditLogTable.styles'
import type { WorkspaceAuditLogItem } from './types'

const { TableCell, TableRow } = TableComponents

export interface WorkspaceAuditLogTableProps {
  items: WorkspaceAuditLogItem[]
  isLoading?: boolean
}

const headers = [
  { label: 'Action' },
  { label: 'Who' },
  { label: 'Details' },
  { label: '' },
]

const loadingComponent = (
  <TableRow>
    <TableCell colSpan={4}>
      <LoadingState />
    </TableCell>
  </TableRow>
)

const noAuditLogItemsComponent = (
  <TableRow>
    <TableCell colSpan={4}>
      <Flex justifyContent="center">No audit log entries found</Flex>
    </TableCell>
  </TableRow>
)

export const WorkspaceAuditLogTable: React.FC<WorkspaceAuditLogTableProps> = ({
  items,
  isLoading,
}) => {
  return (
    <StyledAuditLogTable
      sortable
      isLoading={isLoading}
      loadingComponent={loadingComponent}
      emptyComponent={noAuditLogItemsComponent}
      header={headers}
      items={items}
      renderItem={item => (
        <TableRow>
          <TableCell>
            <AuditActionPill item={item} />
          </TableCell>
          <TableCell>
            <Tooltip
              content={
                [item.actor?.name, item.actor?.email]
                  .filter(Boolean)
                  .join(' — ') || 'Actor unavailable'
              }
              placement="top"
            >
              <Truncate>
                {item.actor?.name || item.actor?.email || 'Actor unavailable'}
              </Truncate>
            </Tooltip>
          </TableCell>
          <DetailsCell>{item.description}</DetailsCell>
          <TableCell>
            {item.createdAt && !Number.isNaN(Date.parse(item.createdAt)) ? (
              <Tooltip
                placement="top"
                content={new Date(item.createdAt).toLocaleString()}
                tooltipContainerAs={'span'}
              >
                <TimeAgo short date={item.createdAt} />
              </Tooltip>
            ) : (
              '—'
            )}
          </TableCell>
        </TableRow>
      )}
    />
  )
}
